/**
 * @generated SignedSource<<5ec3ac195e4ac2bdfc8d173f4bddc9ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailValuesId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormDetailValuesUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFormDetailValuesTPayload",
        "kind": "LinkedField",
        "name": "updateFormDetailValuesTByFormDetailValuesId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailValuesT",
            "kind": "LinkedField",
            "name": "formDetailValuesT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormDetailValuesUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFormDetailValuesTPayload",
        "kind": "LinkedField",
        "name": "updateFormDetailValuesTByFormDetailValuesId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailValuesT",
            "kind": "LinkedField",
            "name": "formDetailValuesT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "403dbd1418924f122b1a71575c253e36",
    "id": null,
    "metadata": {},
    "name": "FormDetailValuesUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation FormDetailValuesUpdateMutation(\n  $input: UpdateFormDetailValuesTByFormDetailValuesIdInput!\n) {\n  updateFormDetailValuesTByFormDetailValuesId(input: $input) {\n    formDetailValuesT {\n      formDetailValuesId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "59c376a8f070ecb51273b4ab9730a023";

module.exports = node;
